import { IComment } from '../components/Comments/Comments.types';
import { ExamTaskGroupSolutionScoreFlag, FinalScoreAuthor, VerificationState } from '../pages/Assessment/Assessment.types';
import { Status } from '../services/exams/assessmentSession/assessments.types';
import { AnnotationsForORGZ } from './annotation.types';
import { CriteriaSetupDto, CriteriaSetupResponseDto } from './session.types';

export interface SchemaExamScore {
  score: number;
  isCommentRequired?: boolean;
  isRequiredCommentAdded?: boolean;
}

export interface ExamScoringSchema {
  examScoringSchemaId: string;
  label: string;
  criterionName: string;
  criterionNumber: string;
  examScoreValues: SchemaExamScore[];
  score: number | null;
  verifierScore: number | null;
  sampleScore: number | null;
  partialScoreId: string;
  assessmentQuality: AssessmentQuality | null;
  isScoringAnnotationRequired: boolean;
}

export interface GradeRule {
  id: string;
  fileName?: string;
  displayName?: string;
  noAnswer: boolean;
}

export interface ExamTask {
  taskId: string;
  taskNumber: string;
  automaticPunctation: boolean;
  noAnswer: boolean | null;
  verifierNoAnswer?: boolean | null;
  examTaskSolutionId: string;
  gradeRule: GradeRule;
  assessmentQuality: AssessmentQuality | null;
  sampleScore?: number | null;
  examScoringSchemas: ExamScoringSchema[];
  solutionScoreId: string;
  criteriaSetup?: CriteriaSetupDto[];
}

export enum AssessmentQuality {
  Accurate,
  WithinTolerance,
  Inaccurate,
}

export interface ExamTaskGroupSolutionWithTasks {
  examTasksCriteria: ExamTask[];
  examTaskGroupSolutionScoreState: Status | null;
  assessmentQuality: AssessmentQuality | null;
  finalAssessmentQuality: AssessmentQuality | null;
  examTaskGroupSolutionScoreId: string;
  isSpecialCaseReported: boolean;
  examSheetGradeRuleFileName?: string | null;
  sampleAssessmentPoints: number | null;
  isReadOnly: boolean;
  isScoringAdjusted: boolean;
  criteriaSetups?: CriteriaSetupResponseDto[];
  examTaskGroupSolutionScoreFlags: ExamTaskGroupSolutionScoreFlag[];
  examTaskNumbersWithNoAnswer: string[];
  examinerLatestVersionId: string | null;
  verifierLatestVersionId: string | null;
  verificationStateId: VerificationState | null;
  finalScoreAuthor: FinalScoreAuthor | null;
}

export enum ExamTaskGroupSolutionDownloadResult {
  SingleSolution,
  FilledUpToLimits,
  NoneExceededLimits,
  NoneNoMoreSolutions,
  NoneExaminerBlocked,
  NoneInvalidProcess,
  NoneProcessFinished,
  DistributionDetailsNotSetUp,
  ScoringProcessIsNotActive,
  NoneSessionClosed,
  NoneSessionSuspended,
  ExaminerShouldReadMessages,
}

export enum deleteState {
  EXAMSHEETISCONFIGURED = 0,
  EXAMTASKEXIST = 1,
  FAILURE = 2,
  SUCCESS = 3,
}

export enum deleteScoringState {
  EXAMSHEETISCONFIGURED = 0,
  EXAMSESSIONNOTFROMONE = 1,
  COORDINATOROFANOTHEREXAMSHEET = 2,
  SUCCESS = 3,
  FAILURE = 4,
}

export enum deleteSheetState {
  EXAMSHEETISCONFIGURED = 0,
  EXAMSESSIONNOTFROMONE = 1,
  SUCCESS = 2,
  FAILURE = 3,
}

export interface ExamTaskGroupSolution {
  id: string;
  state: Status;
  downloadTime: Date;
}

export interface DownloadExamTaskGroupSolution {
  solutionDownloadResult: ExamTaskGroupSolutionDownloadResult;
  solutions: ExamTaskGroupSolution[];
}
export interface ExamTasksCoordinates {
  taskId: string;
  examSheetPages: [
    {
      id: string;
      pageNumber: number;
      examSheetId?: string;
    },
  ];
}

export enum CriterionType {
  leadingCriterion,
  dependentCriterion,
}

export interface ExamTaskGroupSolutionScoreShelfResponse {
  examTaskGroupSolutionScoreVersionId: string;
  commentsDto: IComment[];
  annotationsDto: AnnotationsForORGZ;
  examTasksCriteriaDto: ExamTaskGroupSolutionWithTasks;
}
